import { MIN_QUANTITY, MAX_QUANTITY, ICON_PRICE_IN_DOLLARS } from "./constants";

import {
    purchasePrepaidBalanceMutation,
    purchasePrepaidBalanceRequestData,
} from "./mutations";

import {
    getCurrentPrepaidBalanceQuery,
    getSavedCreditCardQuery,
} from "./queries";

// FORM VALIDATION
export const validateQuantity = ({ quantityToAdd }) => {
    let error = "";

    if (quantityToAdd === 0) {
        error = `Please add ${MIN_QUANTITY} to ${MAX_QUANTITY} icons to your balance.`;
    } else if (quantityToAdd < MIN_QUANTITY) {
        error = `Please add at least ${MIN_QUANTITY} icons to your balance.`;
    } else if (quantityToAdd > MAX_QUANTITY) {
        error = `The maximum number of icons you can add to your balance is ${MAX_QUANTITY}.`;
    }

    return { error, isValid: !!!error };
};

// FORMATTING
export const formatDollarsToCents = ({ amount }) => {
    const amountInCents = amount * 100;
    const amountAsNumber = Number(amountInCents);

    return amountAsNumber;
};

export const getAmountToPurchase = ({ quantityToAdd }) => {
    const amountInDollars = (
        Number(quantityToAdd) * ICON_PRICE_IN_DOLLARS
    ).toFixed(2);
    return amountInDollars;
};

// FETCHING AND MUTATING DATA
const createStripeToken = ({ stripeObjectInstance, stripeTokenData }) => {
    return stripeObjectInstance
        .createToken(stripeTokenData)
        .then(processStripeResponse);

    function processStripeResponse(response) {
        const tokenSuccessfullyCreated = !response.error;

        if (!tokenSuccessfullyCreated) {
            return Promise.reject(response.error);
        }

        return response.token.id;
    }
};

export const purchasePrepaidBalance = ({
    amountInCents,
    saveCreditCard,
    stripeObjectInstance,
    stripeTokenData,
    hasSavedCreditCard,
    updatedCreditCardInfo,
}) => {
    const requestData = {
        ...purchasePrepaidBalanceRequestData,
        purchase_prepaid_balance_cents: amountInCents,
    };

    if (saveCreditCard) requestData.save_card = true;

    const isUsingNewCreditCardInfo =
        !hasSavedCreditCard || (hasSavedCreditCard && updatedCreditCardInfo);

    if (isUsingNewCreditCardInfo) {
        return createStripeToken({
            stripeObjectInstance,
            stripeTokenData,
        })
            .then((stripeToken) => {
                requestData.stripe_token = stripeToken;
                return purchasePrepaidBalanceMutation({ requestData });
            })
            .catch((error) => Promise.reject(error));
    } else {
        return purchasePrepaidBalanceMutation({ requestData }).catch((error) =>
            Promise.reject(error)
        );
    }
};

export const getCurrentPrepaidBalance = () => {
    return getCurrentPrepaidBalanceQuery().then((responseObject) => {
        if (!responseObject.prepaid_balance) return 0;

        const prepaidBalanceInCents = responseObject.prepaid_balance.balance;
        const prepaidBalanceInDollars = Number(prepaidBalanceInCents) / 100;

        return prepaidBalanceInDollars;
    });
};

export const getSavedCreditCard = () => {
    return getSavedCreditCardQuery().then(processResponse);

    function processResponse(response) {
        let savedCreditCardInfo = null;

        if (response.ok) {
            savedCreditCardInfo = response;
        }

        return savedCreditCardInfo;
    }
};
